// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: kvajJ2MSr9DNMA2u1PusCw
// Component: 3h7JHZUTC9UX
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import JsonListItem from "../../JsonListItem"; // plasmic-import: Asiz7K-bnpQ2/component
import BtnText from "../../BtnText"; // plasmic-import: R3LXVa6EIz/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import projectcss from "../blank_project/plasmic_blank_project.module.css"; // plasmic-import: kvajJ2MSr9DNMA2u1PusCw/projectcss
import sty from "./PlasmicJsonListModal.module.css"; // plasmic-import: 3h7JHZUTC9UX/css

createPlasmicElementProxy;

export const PlasmicJsonListModal__VariantProps = new Array();

export const PlasmicJsonListModal__ArgProps = new Array();

const $$ = {};

function PlasmicJsonListModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__eB8E)}>
        <div className={classNames(projectcss.all, sty.freeBox__iV1Tq)}>
          <div className={classNames(projectcss.all, sty.freeBox__uNxk)}>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__wVmBw)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__suIRo)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__imYn1
                  )}
                >
                  {"Please Select"}
                </div>
              </div>
              <div
                data-plasmic-name={"jsonList"}
                data-plasmic-override={overrides.jsonList}
                className={classNames(projectcss.all, sty.jsonList)}
              >
                <JsonListItem
                  data-plasmic-name={"jsonListItem"}
                  data-plasmic-override={overrides.jsonListItem}
                  className={classNames("__wab_instance", sty.jsonListItem)}
                />
              </div>
              <div
                data-plasmic-name={"assessorComment"}
                data-plasmic-override={overrides.assessorComment}
                className={classNames(projectcss.all, sty.assessorComment)}
              />

              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__klXag)}
              >
                {false ? (
                  <BtnText
                    data-plasmic-name={"btnSubmit"}
                    data-plasmic-override={overrides.btnSubmit}
                    className={classNames("__wab_instance", sty.btnSubmit)}
                    green={true}
                  >
                    {"Submit"}
                  </BtnText>
                ) : null}
                <BtnText
                  data-plasmic-name={"btnCloseBottom"}
                  data-plasmic-override={overrides.btnCloseBottom}
                  className={classNames("__wab_instance", sty.btnCloseBottom)}
                  orange={true}
                >
                  {"Submit"}
                </BtnText>
              </Stack__>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__j4Vu0
                )}
              >
                {
                  "The assessment has been submitted, and is ready for release to the moderator. To release the assessment or make changes to your marking, visit the To Be Released section or Return to To Be Marked"
                }
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__yYb9E)}>
                {false ? (
                  <BtnText
                    data-plasmic-name={"btnMark"}
                    data-plasmic-override={overrides.btnMark}
                    className={classNames("__wab_instance", sty.btnMark)}
                    green={true}
                  >
                    {"Submit"}
                  </BtnText>
                ) : null}
                <BtnText
                  data-plasmic-name={"btnRelease"}
                  data-plasmic-override={overrides.btnRelease}
                  className={classNames("__wab_instance", sty.btnRelease)}
                  green={true}
                >
                  {"Submit"}
                </BtnText>
              </div>
              <div
                data-plasmic-name={"loadingSvg2"}
                data-plasmic-override={overrides.loadingSvg2}
                className={classNames(projectcss.all, sty.loadingSvg2)}
              />
            </Stack__>
            <div className={classNames(projectcss.all, sty.freeBox___1OB7T)}>
              <div className={classNames(projectcss.all, sty.freeBox___3UNuV)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__iSiPf
                  )}
                >
                  {"Flags"}
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__fwZXf)}>
                <div className={classNames(projectcss.all, sty.freeBox__fPu6B)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__hV1Nu)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__hZynN
                      )}
                    >
                      {"A -"}
                    </div>
                    <div
                      data-plasmic-name={"txtA"}
                      data-plasmic-override={overrides.txtA}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtA
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___3SNjm)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__l0FCl
                      )}
                    >
                      {"S -"}
                    </div>
                    <div
                      data-plasmic-name={"txtS"}
                      data-plasmic-override={overrides.txtS}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtS
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox___7MwZn)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__qnSdi
                      )}
                    >
                      {"R -"}
                    </div>
                    <div
                      data-plasmic-name={"txtR"}
                      data-plasmic-override={overrides.txtR}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtR
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__fq8O5)}>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__ntEeu)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__upkkK
                      )}
                    >
                      {"B -"}
                    </div>
                    <div
                      data-plasmic-name={"txtB"}
                      data-plasmic-override={overrides.txtB}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtB
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__gEltx)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__hRpzN
                      )}
                    >
                      {"C -"}
                    </div>
                    <div
                      data-plasmic-name={"txtC"}
                      data-plasmic-override={overrides.txtC}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtC
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                  <div
                    className={classNames(projectcss.all, sty.freeBox__f1PCb)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__bbGJq
                      )}
                    >
                      {"P -"}
                    </div>
                    <div
                      data-plasmic-name={"txtP"}
                      data-plasmic-override={overrides.txtP}
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.txtP
                      )}
                    >
                      {" 1"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "jsonList",
    "jsonListItem",
    "assessorComment",
    "btnSubmit",
    "btnCloseBottom",
    "btnMark",
    "btnRelease",
    "loadingSvg2",
    "txtA",
    "txtS",
    "txtR",
    "txtB",
    "txtC",
    "txtP"
  ],

  jsonList: ["jsonList", "jsonListItem"],
  jsonListItem: ["jsonListItem"],
  assessorComment: ["assessorComment"],
  btnSubmit: ["btnSubmit"],
  btnCloseBottom: ["btnCloseBottom"],
  btnMark: ["btnMark"],
  btnRelease: ["btnRelease"],
  loadingSvg2: ["loadingSvg2"],
  txtA: ["txtA"],
  txtS: ["txtS"],
  txtR: ["txtR"],
  txtB: ["txtB"],
  txtC: ["txtC"],
  txtP: ["txtP"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicJsonListModal__ArgProps,
          internalVariantPropNames: PlasmicJsonListModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicJsonListModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicJsonListModal";
  } else {
    func.displayName = `PlasmicJsonListModal.${nodeName}`;
  }
  return func;
}

export const PlasmicJsonListModal = Object.assign(
  // Top-level PlasmicJsonListModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    jsonList: makeNodeComponent("jsonList"),
    jsonListItem: makeNodeComponent("jsonListItem"),
    assessorComment: makeNodeComponent("assessorComment"),
    btnSubmit: makeNodeComponent("btnSubmit"),
    btnCloseBottom: makeNodeComponent("btnCloseBottom"),
    btnMark: makeNodeComponent("btnMark"),
    btnRelease: makeNodeComponent("btnRelease"),
    loadingSvg2: makeNodeComponent("loadingSvg2"),
    txtA: makeNodeComponent("txtA"),
    txtS: makeNodeComponent("txtS"),
    txtR: makeNodeComponent("txtR"),
    txtB: makeNodeComponent("txtB"),
    txtC: makeNodeComponent("txtC"),
    txtP: makeNodeComponent("txtP"),
    // Metadata about props expected for PlasmicJsonListModal
    internalVariantProps: PlasmicJsonListModal__VariantProps,
    internalArgProps: PlasmicJsonListModal__ArgProps
  }
);

export default PlasmicJsonListModal;
/* prettier-ignore-end */
